/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */

/**
 * Describes the position of the element in its "environment"
 */

/**
 * Class to calculate visible viewport-space around a HTML-element.
 */
export class ViewportSpaceAround {
  constructor(target) {
    this._target = target;
  }

  get() {
    this._update();

    return this._space;
  }

  _update() {
    const clientRect = this._target.getBoundingClientRect();

    const top = clientRect.top;
    const right = window.visualViewport.width - clientRect.right;
    const bottom = window.visualViewport.height - clientRect.bottom;
    const left = clientRect.left;
    this._space = {
      top,
      right,
      bottom,
      left
    };
  }

}
